import {
  Outlet,
  Link,
  useLoaderData,
  useParams,
  NavLink
} from "react-router-dom";

import { useState, useEffect } from "react";
import * as API from "../services/documentacion";
import { FormatDate } from "../components/documentacion/FormatDate";

export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getAllDocumentacionByTax(params.tratamientoId);
}

export function DocumentacionList(props) {
  const [documentacionList, setDocumentacion] = useState([]);
  let { tratamientoId } = useParams();
  let { documentacionList2 } = useLoaderData();
  console.log(documentacionList2);

  useEffect(() => {
    API.getAllDocumentacionByTax(props.id).then(setDocumentacion).catch(console.log);
  }, [props.id]);
  return (
    <>
      {documentacionList?.length ? (
            <ul className="documentacion cpt-list">
              {documentacionList?.map((documentacion) => (
                <li key={documentacion.id}>
                  <NavLink to={`${props.id}/documentacion/${documentacion.id}`}>{`${FormatDate(documentacion.meta.docuFecha)}`}</NavLink>
                </li>
              ))}
            </ul>
          ) : (
            <ul className="documentacion cpt-list">
                <li>
                  <Link to={`${props.id}/documentacion/new`}>Nuevo</Link>
                </li>
            </ul>
          )}
    </>
  );
}

function CleanDocTitle(props) {
  switch (props.title) {
    case "CertInfTrat":
      return "Certificado Informe del Tratamiento";
    case "ConInfAlcConSeg":
      return "Consentimiento Informado Alcohol";
    case "ConInfAlcSinSeg":
      return "Consentimiento Informado Alcohol Sin Seguimiento";
    case "ConInfBenzConSeg":
      return "Consentimiento Informado Benzodiacepinas Con Seguimiento";
    case "ConInfBenzSinSeg":
      return "Consentimiento Informado Benzodiacepinas Sin Seguimiento";
    case "ConInfCocConSeg":
      return "Consentimiento Informado Cocaina Con Seguimiento";
    case "ConInfCocSinSeg":
      return "Consentimiento Informado Cocaina Sin Seguimiento";
    case "ConInfHachConSeg":
      return "Consentimiento Informado Hachis Con Seguimiento";
    case "ConInfHachSinSeg":
      return "Consentimiento Informado Hachis Sin Seguimiento";
    case "ConInfHerConSeg":
      return "Consentimiento Informado Heroina Con Seguimiento";
    case "ConInfHerSinSeg":
      return "Consentimiento Informado Heroina Sin Seguimiento";
    case "ConInfMetConSeg":
      return "Consentimiento Informado Metadona Con Seguimiento";
    case "ConInfMetSinSeg":
      return "Consentimiento Informado Metadona Sin Seguimiento";
    case "FactTrat":
      return "Factura Tratamiento";
    case "InfAlta":
      return "Informe de Alta";
    case "InfValPautDec":
      return "Informe Valoracion con Pauta Decalaje";
    case "VolPetAnal":
      return "Volante Peticion Analitica";
    case "VolPetCov":
      return "Volante Test COVID";
    case "CuestSalud":
        return "Cuestionario de Salud";
    case "OtrosDoc":
        return "Otros Documentos";    
    default:
      return "Documento sin nombre";
  }
}

export function DocumentacionListContent() {
  const documentacionList = useLoaderData();
  console.log(documentacionList);


  return (
    <>
      <div id="content">
        <h1>Resumen de documentos creados</h1>
          {documentacionList.length ? (
            <ul className="documentacion cpt-list">
              {documentacionList.map((documentacion) => (
                <li key={documentacion.id}>
                {documentacion.meta?.docData?.docFecha}: <Link to={`${documentacion.id}`}>
                  <CleanDocTitle title={documentacion.meta.docTitulo} />
                  {documentacion.meta?.docData?.docNombreDocumento && (
                    <span>: {documentacion.meta?.docData?.docNombreDocumento}</span>
                  )}
                </Link>
                <span> - </span>
                {documentacion.meta?.docFileLink ? (
                   <a href={`${documentacion.meta?.docFileLink}`}>Documento firmado</a>
                  ) : (
                    "Documento sin firmar"
                )}
                </li>
              ))}
            </ul>
          ) : (
            <ul className="documentacion cpt-list">
                <li>
                  Sin documentos creados
                </li>
            </ul>
          )}
      </div>
      <div id="actions">
        <Link className="button is-link" to={`new`}>Nuevo</Link>
        {/* {<a className="button is-link"  style={{cursor: 'not-allowed'}}>Nuevo</a>} */}
      </div>
    </>
  );
}